"use client";
import { definitions } from "@/services/metruyenvl";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import Image from "next/image";
import { TitleCard } from "@/layouts/styles/ssr.style";
import { TableHistoriesCoin } from "@/modules/tab-user";
import { userInfo, getCoinUser, getListOrderCoin } from "@/redux/reducers/user.reducer";

function UserCoinTab({ user }: { user: definitions["do.UserDO"] }) {
    const dispatch = useDispatch();
    const userReducer: any = useSelector(userInfo);
    useEffect(() => {
        dispatch(getCoinUser());
        dispatch(getListOrderCoin({ page: 1, pageSize: 10 }));
    }, []);
    return (
        <div>
            {" "}
            <div className="w-full flex justify-between items-center pt-6 pb-6 pl-4 border-b border-stone-200 border-solid border-t">
                <div className="flex items-center gap-x-3">
                    <Image unoptimized={true} src="/candies.png" width={24} height={24} className="h-6 w-6" alt="" />
                    {/* <img src="/candies.png" className="h-6 w-6" alt="" /> */}
                    <div>
                        <TitleCard>Đang có {userReducer?.coinUser?.coin ?? 0} kẹo</TitleCard>
                        <div className="text-slate-400 mt-2">Bao gồm {userReducer?.coinUser?.bonus_coin ?? 0} kẹo miễn phí</div>
                    </div>
                </div>
                <button className="float-right mt-4 mb-4 bg-orange-400 rounded-lg p-2 text-slate-500 hover:text-white font-semibold">Nhận thưởng</button>
            </div>
            <div className="mt-3">
                {" "}
                <TitleCard styles={{ marginBottom: "8px" }}>Lịch sử</TitleCard>
                <TableHistoriesCoin />
            </div>
        </div>
    );
}

export default UserCoinTab;
